define('drops/richTextEditor/richTextEditor',[
    'jquery',
    'when',
    'lq/drop',
    'lq/uploader',
    'lq/style',
    'lq',
    'lq/required'
], function ($, when, Drop, Uploader, Style, lq, Required) {
    'use strict';

    var tinymce = null;

    var tenantUrlPlaceholder = '{{{TenantUrl}}}';

    var supportedLanguages = ["ar", "ar_SA", "hy", "az", "eu", "be", "bn_BD", "bs", "bg_BG", "ca", "zh_CN", "zh_TW", "hr", "cs", "da", "dv", "nl",
        "en_CA", "en_GB", "et", "fo", "fi", "fr_FR", "gd", "gl", "ka_GE", "de", "de_AT", "el", "he_IL", "hi_IN", "hu_HU", "is_IS", "id", "it", "ja",
        "kab", "kk", "km_KH", "ko_KR", "ku", "ku_IQ", "lv", "lt", "lb", "ml", "ml_IN", "mn_MN", "nb_NO", "fa", "fa_IR", "pl", "pt_BR", "pt_PT", "ro",
        "ru", "sr", "si_LK", "sk", "sl_SI", "es", "es_MX", "sv_SE", "tg", "ta", "ta_IN", "tt", "th_TH", "tr", "tr_TR", "ug", "uk", "uk_UA", "vi", "vi_VN", "cy"];
    var licquidLanguageMap = {
        "zh": "zh_CN",
        "en-GB": "en_GB",
        "fr": "fr_FR",
        "hu": "hu_HU",
        "ko": "ko_KR",
        "nb": "nb_NO",
        "pt": "pt_PT",
        "sv": "sv_SE",
        "tr": "tr_TR"
    };

    var defaults = {
        data: {
            readonly: false,
            undoRedoEnabled: true,
            boldEnabled: true,
            italicEnabled: true,
            underlineEnabled: true,
            stripFormattingOnPaste: true,
            spellcheckerEnabled: false,
            strikethroughEnabled: false,
            formatselectEnabled: false,
            removeformatEnabled: false,
            fullscreenEnabled: false,
            previewEnabled: false,
            printEnabled: false,
            anchorEnabled: false,
            cutEnabled: false,
            copyEnabled: false,
            pasteEnabled: false,
            selectallEnabled: false,
            searchreplaceEnabled: false,
            superscriptEnabled: false,
            subscriptEnabled: false,
            lineheightEnabled: false,
            wordcountEnabled: false,
            runtimeResizeEnabled: false,
            size: {
                x: 400,
                y: 250
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            skin: 'tinymce-5',
            watermark: ''
        }
    };

    function RichTextEditor(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;
        this.$element
            .addClass('boxToBorderSize rich-text-editor empty')
            .css({
                whiteSpace: 'pre-wrap'
            })
            .attr('tabindex', this.data.tabIndex)
            .on('focus', function() {
                self.focus();
            });
        this.elementId = _.uniqueId('rte_');
        this.initialUpdate = null;

        this.$textarea = $('<textarea id="' + this.elementId + '" />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);

        Style.renderStyles(this);

        this.triggerChangedEvent = _.debounce(this.triggerEventIfEnabled.bind(this, 'changed'), 200);
    };

    Drop.extend(RichTextEditor, Drop);

    RichTextEditor.typeName = 'RichTextEditor';

    RichTextEditor.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();

        if (!tinymce) {
            var deferred = when.defer();
            require([
                'tinymce'
            ],
                function (lazyLoadedTinymce) {
                    tinymce = lazyLoadedTinymce;
                    deferred.resolve();
                });

            return deferred.promise;
        }
    };

    RichTextEditor.prototype.postRender = function () {
        this.createRichTextEditor();
    };

    RichTextEditor.prototype.createRichTextEditor = function () {
        this.toolbar = this.buildToolbar();

        if (this.toolbar)
            this.$element.addClass('with-toolbar');

        var self = this;

        var configuration = {
            selector: 'textarea#' + this.elementId,
            body_class: this.getCssClassNameForStyling(),
            width: '100%',
            height: '100%',
            menubar: false,
            statusbar: this.data.runtimeResizeEnabled,
            plugins: this.buildPluginsList(),
            toolbar: this.toolbar ? this.toolbar : false,
            paste_as_text: this.data.stripFormattingOnPaste,
            paste_data_images: this.data.imagesEnabled,
            images_upload_handler: (blobInfo, progress) =>
                self.imageUploadHandler.call(self, blobInfo, progress),
            image_dimensions: !this.data.containImagesEnabled,
            content_style: this.buildContentStyles(),
            relative_urls: false,
            remove_script_host: false,
            readonly: this.data.readonly,
            browser_spellcheck: this.data.spellcheckerEnabled,
            file_browser_callback: this.openFileBrowser.bind(this),
            cache_suffix: require_config.urlArgs(null, ''),
            setup: function(ed) {
                if (self.isEventEnabled('changed')) {
                    ed.on('change', self.contentChanged.bind(self));
                    ed.on('keyup', self.contentChanged.bind(self));
                } else {
                    ed.on('keyup', self.updateEmptyState.bind(self));
                }

                ed.on('init', function() {
                    self.editor = ed;

                    if (self.initialUpdate) {
                        self.setValue(self.initialUpdate);
                        self.initialUpdate = null;
                    }
                });

                if (self.data.disableParagraphs) {
                    ed.on('keydown', function (event) {
                        if (event.keyCode !== 13 || !event.shiftKey)
                            return true;
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    });
                }

                if (self.data.hasMaxLength) {
                    var allowedKeys = [8, 35, 36, 37, 38, 39, 40, 46];

                    ed.on('keydown', function(e) {
                        if (allowedKeys.indexOf(e.keyCode) !== -1)
                            return true;

                        if (self.getLengthOfContent() + 1 <= self.data.maxLength)
                            return true;

                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    });
                }
            },
            styles: {
                bold: { inline: 'b' },
                italic: { inline: 'i' },
                underline: { inline: 'u' }
            },
            text_patterns: [
                { start: '*', end: '*', format: 'italic' },
                { start: '**', end: '**', format: 'bold' },
            ],
            extended_valid_elements: 'b,i,u',
            content_css: lq.getTenantUrl('StyleSheet/Get?v=' + lq.getStylesVersion()),
            urlconverter_callback: function(url, node, on_save, name) {
                // note: replace with placeholder only for images. Other links are beyond our control.
                return node === 'img' ? url.replace(origin + lq.getTenantUrl(''), tenantUrlPlaceholder) : url;
            },
            file_picker_callback: this.openFileBrowser.bind(this),
            language: self.getLanguage.call(this) || "en_GB",
            elementpath: false,
            skin: this.getSkin(),
            content_css: this.getSkin(),
            placeholder: this.data.watermark
        };

        if (this.data.disableParagraphs)
            configuration.newline_behavior = 'linebreak';

        if (this.data.hasMaxLength) {
            configuration.paste_preprocess = function(plugin, args) {
                var newLength = self.getLengthOfContent() + args.content.length;

                if (newLength > self.data.maxLength)
                    args.content = '';
            };
        }

        if (this.data.stripFormattingOnPaste) {
            configuration.paste_postprocess  = function(plugin, args) {
                var value = args.node.innerHTML;
                if (value && value.match(/\&nbsp;/g)) {
                    args.node.innerHTML = value.replace(/\&nbsp;/g, '');
                }
            };
        }

        // for some reason this is needed when running an SPA
        setTimeout(function () {
            tinymce.init(configuration);
            self.updateEmptyState(self);
        }, 0);
    };

    RichTextEditor.prototype.buildContentStyles = function () {
        var contentStyles = "";

        if (this.data.containImagesEnabled) {
            contentStyles += "img { width: 100% !important; height: auto !important; } ";
        }

        if (this.data.removeMarginAndPadding) {
            contentStyles += "p { margin: 0; padding: 0; } ";
        }

        return contentStyles;
    };

    RichTextEditor.prototype.getSkin = function () {
        if (this.data.skin === 'tinymce-6') return undefined;
        else return this.data.skin;
    };

    RichTextEditor.prototype.imageUploadHandler = function (blobInfo, progress) {
        var self = this;
        return new Promise(function(resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.withCredentials = false;

            var params = {
                qqfile: blobInfo.filename(),
                actionId: self.piping.actionId,
                dropId: self.data.id,
                isCommand: false
            };

            xhr.open('POST', lq.getTenantUrl('DynamicContent/AddPermanentFile?' + $.param(params)));
            xhr.setRequestHeader("x-file-name", encodeURIComponent(blobInfo.filename()));

            xhr.upload.onprogress = function (e) {
                progress(e.loaded / e.total * 100);
            };

            xhr.onload = function () {
                if (xhr.status === 403) {
                    reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
                    return;
                }

                if (xhr.status < 200 || xhr.status >= 300) {
                    reject('HTTP Error: ' + xhr.status);
                    return;
                }

                const json = JSON.parse(xhr.responseText);

                if (json && json.errorType === 'sizeLimitExceeded') {
                    reject(blobInfo.filename() + ' is too large, maximum file size is ' + json.maxFileSizeInKb + 'KB')
                    return;
                }

                if (!json || typeof json.url != 'string') {
                    reject('Invalid JSON: ' + xhr.responseText);
                    return;
                }

                resolve(lq.getTenantUrl('DynamicContent/File/' + json.url));
            };

            xhr.onerror = function () {
                reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
            };

            xhr.send(blobInfo.blob());
        });
    };

    RichTextEditor.prototype.getLengthOfContent = function() {
        return this.editor
            .getContent({ format: 'text' })
            .replace(/(\r\n\t|\n|\r\t)/gm, '')
            .length;
    };

    RichTextEditor.prototype.contentChanged = function () {
        var value = this.editor.getContent();

        if (value === this.lastChange)
            return;

        this.lastChange = value;

        if (this.data.required)
            this.updateRequiredIndicator();

        this.triggerChangedEvent();
        this.updateEmptyState();
    };

    RichTextEditor.prototype.getCssClassNameForStyling = function() {
        var actualStyle = this.data.styles;
        var prefix = 'userstyle-';

        if (!actualStyle) {
            var styleId = Style.getDefaultStyleIdByDropType(this);
            if (styleId) return Style.getClassNameFromStyleId(prefix, styleId);
        } else if (typeof actualStyle === 'string') {
            return Style.getClassNameFromStyleId(prefix, actualStyle);
        }

        return '';
    };

    RichTextEditor.prototype.buildPluginsList = function () {
        var plugins = '';
        if (this.data.insertLinkEnabled)
            plugins += ' link';
        if (this.data.imagesEnabled)
            plugins += ' image';
        if (this.data.insertListEnabled)
            plugins += ' lists';
        if (this.data.tablesEnabled)
            plugins += ' table';
        if (this.data.fullscreenEnabled)
            plugins += ' fullscreen';
        if (this.data.previewEnabled)
            plugins += ' preview';
        if (this.data.anchorEnabled)
            plugins += ' anchor';
        if (this.data.searchreplaceEnabled)
            plugins += ' searchreplace';
        if (this.data.wordcountEnabled)
            plugins += ' wordcount';

        return plugins;
    };

    RichTextEditor.prototype.buildToolbar = function () {
        var toolbar = '';

        if (this.data.undoRedoEnabled)
            toolbar += ' undo redo';

        if (toolbar)
            toolbar += ' |';

        if (this.data.boldEnabled)
            toolbar += ' bold';
        if (this.data.italicEnabled)
            toolbar += ' italic';
        if (this.data.underlineEnabled)
            toolbar += ' underline';
        if (this.data.strikethroughEnabled)
            toolbar += ' strikethrough';

        if (toolbar)
            toolbar += ' |';

        if (this.data.fontFamilyEnabled)
            toolbar += ' fontfamily';
        if (this.data.fontSizeEnabled)
            toolbar += ' fontsize';
        if (this.data.fontForegroundEnabled)
            toolbar += ' forecolor';
        if (this.data.fontBackgroundEnabled)
            toolbar += ' backcolor';

        if (toolbar)
            toolbar += ' |';

        if (this.data.textAlignEnabled)
            toolbar += ' alignleft aligncenter alignright alignjustify';

        if (toolbar)
            toolbar += ' |';

        if (this.data.insertLinkEnabled)
            toolbar += ' link unlink';

        if (toolbar)
            toolbar += ' |';

        if (this.data.insertListEnabled)
            toolbar += ' bullist numlist';

        if (toolbar)
            toolbar += ' |';

        if (this.data.indentationEnabled)
            toolbar += ' outdent indent';

        if (toolbar)
            toolbar += ' |';

        if (this.data.tablesEnabled)
            toolbar += ' table';

        if (toolbar)
            toolbar += ' |';

        if (this.data.imagesEnabled)
            toolbar += ' image';

        if (this.data.formatselectEnabled)
            toolbar += ' blocks';

        if (this.data.removeformatEnabled)
            toolbar += ' removeformat';

        if (this.data.fullscreenEnabled)
            toolbar += ' fullscreen';

        if (this.data.previewEnabled)
            toolbar += ' preview';

        if (this.data.printEnabled)
            toolbar += ' print';

        if (this.data.anchorEnabled)
            toolbar += ' anchor';

        if (this.data.cutEnabled)
            toolbar += ' cut';

        if (this.data.copyEnabled)
            toolbar += ' copy';

        if (this.data.pasteEnabled)
            toolbar += ' paste';

        if (this.data.selectallEnabled)
            toolbar += ' selectall';

        if (this.data.searchreplaceEnabled)
            toolbar += ' searchreplace';

        if (this.data.superscriptEnabled)
            toolbar += ' superscript';

        if (this.data.subscriptEnabled)
            toolbar += ' subscript';

        if (this.data.lineheightEnabled)
            toolbar += ' lineheight';

        if (this.data.wordcountEnabled)
            toolbar += ' wordcount';

        return toolbar;
    };

    RichTextEditor.prototype.focus = function () {
        if (this.editor) {
            this.editor.focus();
        } else {
            var self = this;
            _.defer(function () {
                self.focus();
            });
        }
    };

    RichTextEditor.prototype.getValue = function () {
        if (!this.editor) return null;
        var content = this.editor.getContent();
        return this.data.disableParagraphs ? content.replace(/(^<p>)|(<\/p>$)/g, '') : content;
    };

    RichTextEditor.prototype.clearValue = function () {
        if (!this.editor) return;

        this.editor.setContent('');
        this.lastChange = '';
        this.updateEmptyState();
    };

    RichTextEditor.prototype.setValue = function (update) {
        if (this.editor) {
            if (update.value) {
                var regex = new RegExp(tenantUrlPlaceholder, 'g');
                var content = update.value.replace(regex, lq.getTenantUrl(''));
                this.editor.setContent(content);
                this.lastChange = content;
            } else {
                // note Tinymce doesn't handle 'null' very well
                this.editor.setContent('');
                this.lastChange = '';
            }

            this.updateRequiredIndicator();
        } else {
            this.initialUpdate = update;
        }
        this.updateEmptyState();
    };

    RichTextEditor.prototype.hasValue = function () {
        if (!this.editor) return false;
        return $.trim(this.editor.getContent({ format: 'text' })) !== '';
    };

    RichTextEditor.prototype.openFileBrowser = function (cb, value, meta) {
        var self = this;
        var uploader = new Uploader(this.piping, this.data.id)
            .toTenantUrl("DynamicContent/AddPermanentFile")
            .withFileFilter('image/*')
            .onFileUploaded(function (uploadResponse) {
                if (!uploadResponse.success)
                    throw new Error('Upload failed.');

                var imageUrl = lq.getTenantUrl('DynamicContent/File'
                    + '?id=' + encodeURIComponent(uploadResponse.url)
                    + '&filename=' + encodeURIComponent(uploadResponse.filename));

                cb((window.location.origin + (imageUrl.charAt(0) === '/' ? imageUrl : '/' + imageUrl)), { title: uploadResponse.filename});
            })
            .onUploadFinished(function() {
                self.piping.busyIndicator.hide();
            })
            .onFileUploadCancel(function () {
                self.piping.busyIndicator.hide();
                self.triggerEventIfEnabled('fileUploadCancelled');
            });

        uploader.uploadSingleFile();
    };

    RichTextEditor.prototype.getLanguage = function () {
        var sysParams = this.piping.parameters.systems.getAll();
        var runtimeLanguage = sysParams['CurrentLanguageISOCode'];
        if (runtimeLanguage) {
            var licquidLanguage = licquidLanguageMap[runtimeLanguage] || runtimeLanguage;
            if (supportedLanguages.indexOf(licquidLanguage) !== -1)
                return licquidLanguage;
        }

        var browserLanguages = navigator.languages || (navigator.userLanguage ? [navigator.userLanguage] : []);
        for (var i = 0; i < browserLanguages.length; i++) {
            var lang = browserLanguages[i].replace('-', '_');
            if (supportedLanguages.indexOf(lang)!== -1)
                return lang;
        }
    }

    RichTextEditor.prototype.unsubscribeEventHandlers = function () {
        if (!this.editor) return;
        tinymce.remove('#' + this.elementId);
    };

    RichTextEditor.prototype.updateEmptyState = function () {
        if (!this.hasValue()) {
            this.$element.addClass('empty');
        } else {
            this.$element.removeClass('empty');
        }
    };

    return RichTextEditor;
});
